import React, { useEffect } from "react";
import "./About.css";
import TrendingSlider from "../TrendingSliderComp/TrendingSlider";
import OurMaster from "../OurMasterPage/OurMaster";
import OurInstructors from "../OurInstructorsPage/OurInstructors";

const About = () => {
  useEffect(() => {
    const contentWrappers = document.querySelectorAll(".content-wrapper");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.3 }
    );

    contentWrappers.forEach((wrapper) => observer.observe(wrapper));

    return () => observer.disconnect(); // Clean up observer
  }, []);

  return (
    <div className="about-container">

      <div className="trending-slider">
        <h1>Journey of a SOIK Student</h1>
        <TrendingSlider />
      </div>

      <h1>ABOUT SOIK</h1>

      <div className="content-wrapper">
        <img src="/images/karate_punch.png" alt="Bullet" className="bullet" />
        <p className="content">
          The School of Indian Karate (SoIK) is devoted to teaching self-defense, enhancing concentration, building self-confidence, and fostering mental awareness and full-body control through discipline and physical fitness. With the expertise honed over the years by Grand Master Suresh S. Rao, SoIK has achieved substantial excellence by winning state, national, and international championships.
        </p>
      </div>

      <div className="content-wrapper">
        <img src="/images/karate_punch.png" alt="Bullet" className="bullet" />
        <p className="content">
          Over the past years, SoIK has consistently produced champions while shaping students’ skill to excel in competitive arenas. The school takes pride in training achievers from diverse fields, including law enforcement, military, medicine, engineering, education, and software professions.
        </p>
      </div>

      <div className="content-wrapper">
        <img src="/images/karate_punch.png" alt="Bullet" className="bullet" />
        <p className="content highlight">
          With a legacy of training over 4,000 students across all age groups, SoIK is the premier institute for self-defense training, offering expert instruction and advanced techniques to ensure holistic development.
        </p>
      </div>

      <div className="master">
        <OurMaster />
      </div>

      <div className="instructors">
        <OurInstructors />
      </div>
    </div>
  );
};

export default About;